import { postBiz, json, rows, fetchCombo,  } from '../core/coreapi';
import { PlanningCycleCreatePayload, PlanningCycleFilters } from './planningCycle.models';
import { normalizePlanningCycleRow } from './planningCycle.normalize';

export const fetchPlanningCycleCards = async () =>
  json(await postBiz({s: 'planningcycle', a: 'cards', }));

export const fetchPlanningCycles = async (filters: PlanningCycleFilters) =>
  rows(await postBiz({s: 'planningcycle', a: 'find',
    bpi: filters.budgetperiodid ?? null,
    sti: filters.stateid ?? null,
    phi: filters.phaseid ?? null,
    sts: filters.status ?? 1,
    pgo: filters.page ?? 0,
    pgl: filters.pagesize ?? 50,
  })).map(normalizePlanningCycleRow);

export const createPlanningCycle = async (payload: PlanningCycleCreatePayload) =>
  json(await postBiz({s: 'planningcycle', a: 'create',
    bpi: payload.budgetperiodid,
    nam: payload.name,
    dsc: payload.description ?? '',
  }));

export const activatePlanningCycle = async (rid: number) =>
  json(await postBiz({s: 'planningcycle', a: 'activate', rid }));

export const advancePlanningCycle = async (rid: number, phasecode: string, notes = '') =>
  json(await postBiz({s: 'planningcycle', a: 'advance', rid, phc: phasecode, nts: notes }));

export const closePlanningCycle = async (rid: number, notes = '') =>
  json(await postBiz({s: 'planningcycle', a: 'close', rid, nts: notes }));

export const fetchBudgetPeriodOptions = async () =>
  fetchCombo('budgetperiod');

export const fetchPlanningCycleStateOptions = async () =>
  fetchCombo('planningcyclestate');

export const fetchPlanningCyclePhaseOptions = async () =>
  fetchCombo('planningcyclephase');
